import { PAYMENT_MESSAGES } from './paymentCopy';

export function paymentOptionUnavailableMessage(reason) {
  if (reason === 'MULTI_VENDOR_CART') {
    return PAYMENT_MESSAGES.multiVendorUnavailable;
  }
  if (reason === 'PLATFORM_ITEMS_IN_CART') {
    return PAYMENT_MESSAGES.platformItemsUnavailable;
  }
  if (reason === 'PAYMENT_NOT_REQUIRED') {
    return PAYMENT_MESSAGES.paymentNotRequired;
  }
  return PAYMENT_MESSAGES.paymentOptionUnavailable;
}

export function paymentErrorMessage(error, status) {
  if (status === 502) return PAYMENT_MESSAGES.gatewayUnavailable;
  const detail = typeof error?.detail === 'string' ? error.detail : '';
  const code = error?.code ?? error?.detail?.code;
  const reason = error?.detail?.reason;
  if (code === 'PAYMENT_OPTION_UNAVAILABLE') {
    return paymentOptionUnavailableMessage(reason);
  }
  if (
    code === 'SELLER_GATEWAY_CREDIT_LIMIT'
    || reason === 'VENDOR_NEGATIVE_BALANCE_LIMIT'
  ) {
    return PAYMENT_MESSAGES.sellerGatewayUnavailable;
  }
  if (code === 'PENDING_PAYMENT_MODE_MISMATCH') {
    return PAYMENT_MESSAGES.pendingModeMismatch;
  }
  if (code === 'CHEQUE_TERMS_REQUIRED') {
    return PAYMENT_MESSAGES.chequeTermsRequired;
  }
  if (
    code === 'INSUFFICIENT_KALABARG'
    || code === 'INSUFFICIENT_BALANCE'
    || /kalabarg|کالابرگ/i.test(detail)
  ) {
    return PAYMENT_MESSAGES.kalabargUnavailable;
  }
  return PAYMENT_MESSAGES.genericError;
}

export function navigateToPaymentRedirect(redirect) {
  if (!redirect?.url) return;
  if (redirect.method === 'GET') {
    window.location.assign(redirect.url);
    return;
  }
  if (redirect.method !== 'POST') {
    throw new Error('روش انتقال پرداخت پشتیبانی نمی‌شود.');
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = redirect.url;
  form.hidden = true;
  Object.entries(redirect.fields ?? {}).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
